
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Comment segmenter votre audience pour optimiser vos Instagram Ads",
    description:
      "Découvrez comment segmenter efficacement votre audience sur Instagram Ads et maximiser vos performances avec ALEO, experts en campagnes ciblées sur la suite META.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
